/**
 * @file tradingVars.js
 * @description Provides trading-related variables and constants
 *
 * @section Responsibilities
 * - Define trading variables
 * - Provide trading constants
 * - Manage trading configurations
 * - Handle trading defaults
 * - Process trading data
 * - Provide trading utilities
 *
 * @section Dependencies
 * - ConfigService: Configuration management
 * - DataService: Data processing
 * - ValidationService: Data validation
 * - UtilityService: Utility functions
 *
 * @section Integration Points
 * - Config System: Configuration management
 * - Data System: Data processing
 * - Validation System: Data validation
 * - Utility System: Utility functions
 *
 * @section State Management
 * - configState: Configuration status
 * - dataState: Data status
 * - validationState: Validation status
 * - utilityState: Utility status
 *
 * @section Events
 * - onConfigChange: Configuration updates
 * - onDataProcess: Data processing
 * - onValidation: Data validation
 * - onUtility: Utility operations
 *
 * @section Exports
 * @export {Object} tradingVars - Trading variables
 * @export {Object} tradingConfig - Trading configuration
 * @export {Object} tradingDefaults - Default values
 * @export {Function} processTradingData - Data processing
 */

export const OrderClasses = {
  EQUITY: {
    value: "equity",
    name: "Equity",
  },
  OPTION: {
    value: "option",
    name: "Option",
  },
  MULTILEG: {
    value: "multileg",
    name: "Multileg",
  },
  // "COMBO": {
  //     "value": "combo",
  //     "name": "Combo"
  // }
};

export const OrderSides = {
  BUY: {
    value: "buy",
    name: "Buy",
  },
  BUY_TO_COVER: {
    value: "buy_to_cover",
    name: "Buy to cover",
  },
  SELL: {
    value: "sell",
    name: "Sell",
  },
  SELL_SHORT: {
    value: "sell_short",
    name: "Sell short",
  },
};

export const OrderTypes = {
  MARKET: {
    value: "market",
    name: "Market",
  },
  LIMIT: {
    value: "limit",
    name: "Limit",
  },
  STOP: {
    value: "stop",
    name: "Stop",
  },
  STOP_LIMIT: {
    value: "stop_limit",
    name: "Stop limit",
  },
};

export const OrderDurations = {
  DAY: {
    value: "day",
    name: "Day",
  },
  GTC: {
    value: "gtc",
    name: "GTC",
  },
  PRE: {
    value: "pre",
    name: "Pre",
  },
  POST: {
    value: "post",
    name: "Post",
  },
};

export const OrderOptionTypes = {
  PUT: {
    value: "P",
    name: "Put",
  },
  CALL: {
    value: "C",
    name: "Call",
  },
};
